<template>
	<div>
		<TilteParallax
			image="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
		>
			<div class="d-flex align-center">
				<h1 class="display-1 font-weight-thin">
					Sección
				</h1>
			</div>

			<template v-slot:subtitle> </template>
		</TilteParallax>

		<v-container fluid class="mt-0"> </v-container>
	</div>
</template>

<script>
import TilteParallax from "@/components/TilteParallax";

export default {
	name: "Show",

	components: { TilteParallax },

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped></style>
